import { z } from 'zod';

import { FacetedFilterOperator } from '@shared/api/findings/findings.types';

export const filterFormSchema = z.object({
  selectedFields: z.array(z.string()),
  fieldValues: z.record(
    z.string(),
    z.object({
      operator: z.enum([FacetedFilterOperator.IS, FacetedFilterOperator.NOT]),
      values: z.array(z.string()),
      addedWithZeroValues: z.boolean().optional(),
    }),
  ),
});

export type FilterFormValues = z.infer<typeof filterFormSchema>;
